import { Link } from 'react-router-dom';
import Button from '@/components/ui/Button';

export default function LandingPage() {
  return (
    <main className="relative h-full w-full overflow-hidden bg-pirate-dark text-white">
      <video
        className="absolute inset-0 h-full w-full object-cover"
        src="/videos/vd-homepage.mp4"
        autoPlay
        muted
        loop
        playsInline
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-pirate-dark/35 to-pirate-dark" />

      <section className="relative z-10 flex h-full flex-col justify-end px-5 pb-10">
        <div className="mb-8">
          <picture>
            <source srcSet="/branding/logo-hakkencity.webp" type="image/webp" />
            <img src="/branding/logo-hakkencity-opt.png" alt="Hakken City" className="mb-5 h-24 w-auto max-w-[250px] object-contain drop-shadow-lg" />
          </picture>
          <p className="font-serif text-sm font-bold uppercase tracking-[0.24em] text-accent">Exploração urbana</p>
          <h1 className="mt-2 font-display text-5xl font-black leading-none text-accent drop-shadow-lg">
            Hakken City
          </h1>
          <p className="mt-4 max-w-sm text-base font-semibold text-white/85">
            Descobre Aveiro, visita pontos reais da cidade e troca tesouros por recompensas locais.
          </p>
        </div>

        <div className="grid gap-3">
          <Link to="/register"><Button fullWidth variant="gold">Começar aventura</Button></Link>
          <Link to="/login"><Button fullWidth variant="ghost">Entrar</Button></Link>
        </div>
      </section>
    </main>
  );
}
